import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import PrivateRoute from '@/components/auth/PrivateRoute';
import Login from '@/views/Login';
import Dashboard from '@/views/Dashboard';
import DriverList from '@/views/DriverList';
import DriverForm from '@/views/DriverForm';
import VehicleList from '@/views/VehicleList';
import BillingView from '@/views/BillingView';
import FinanceDashboard from '@/views/FinanceDashboard';
import ImportManager from '@/views/ImportManager';
import WalletDetail from '@/views/WalletDetail';
import PayoutManager from '@/views/PayoutManager';
import SepaPaymentManager from '@/views/SepaPaymentManager';
import ComplianceDashboard from '@/views/ComplianceDashboard';
import ComplianceList from '@/views/ComplianceList';
import DocumentPage from '@/views/DocumentPage';
import GoLiveChecklist from '@/views/GoLiveChecklist';
import DriverInviteManager from '@/views/DriverInviteManager';
import SetupWizard from '@/views/SetupWizard';
import AutoImportView from '@/views/AutoImportView';
import FiscalView from '@/views/FiscalView';
import ComplianceView from '@/views/ComplianceView';
import DriverAppView from '@/views/DriverAppView';
import WeekManagement from '@/views/WeekManagement';
import FineManagement from '@/views/FineManagement';
import PartnerManagement from '@/views/PartnerManagement';
import ServiceOrderManagement from '@/views/ServiceOrderManagement';
import AuditDashboard from '@/views/AuditDashboard';

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/*" element={
        isAuthenticated ? (
          <PrivateRoute>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/drivers" element={<DriverList />} />
              <Route path="/drivers/new" element={<DriverForm />} />
              <Route path="/drivers/edit/:id" element={<DriverForm />} />
              <Route path="/drivers/docs/:id" element={<DocumentPage entityType="driver" />} />
              <Route path="/drivers/invites" element={<DriverInviteManager />} />
              <Route path="/vehicles" element={<VehicleList />} />
              <Route path="/vehicles/docs/:id" element={<DocumentPage entityType="vehicle" />} />

              <Route path="/finance" element={<FinanceDashboard />} />
              <Route path="/finance/import" element={<ImportManager />} />
              <Route path="/finance/wallet/:id" element={<WalletDetail />} />
              <Route path="/finance/payout/:driver_id" element={<PayoutManager />} />
              <Route path="/finance/sepa" element={<SepaPaymentManager />} />

              <Route path="/compliance" element={<ComplianceList />} />
              <Route path="/compliance/drivers" element={<ComplianceList entityFilter="driver" />} />
              <Route path="/compliance/vehicles" element={<ComplianceList entityFilter="vehicle" />} />
              <Route path="/compliance/dashboard" element={<ComplianceDashboard />} />
              <Route path="/compliance/go-live" element={<GoLiveChecklist />} />
              <Route path="/compliance/invites" element={<DriverInviteManager />} />

              <Route path="/onboarding/setup" element={<SetupWizard />} />

              <Route path="/weeks" element={<WeekManagement />} />
              <Route path="/fines" element={<FineManagement />} />
              <Route path="/partners" element={<PartnerManagement />} />
              <Route path="/service-orders" element={<ServiceOrderManagement />} />
              <Route path="/audit" element={<AuditDashboard />} />

              <Route path="/auto-import" element={<AutoImportView />} />
              <Route path="/fiscal" element={<FiscalView />} />
              <Route path="/compliance/fiscal" element={<ComplianceView />} />
              <Route path="/driver-app" element={<DriverAppView />} />

              <Route path="/billing" element={<BillingView />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </PrivateRoute>
        ) : (
          <Navigate to="/login" replace />
        )
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
